import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosinhghadfort() {


const cardData = {
keyword: "Pune to Sinhagad Fort Bus on rent in Pune",
headingDescription: "Ruturaj Enterprises provides Pune to Sinhagad Fort Bus on rent in Pune for families, friends, trekking groups, schools, corporate teams, tourists, and large groups planning a convenient day trip. Dedicated AC, luxury, and suitable-capacity buses can be arranged for Sinhagad sightseeing, fort visits, picnics, weekend outings, and group trekking programs. From convenient pickup points in Pune to the Sinhagad Fort region and return journey, transportation can be organized according to passenger strength, itinerary, travel schedule, and group requirements.",
topPlaces: [
{
title: "Sinhagad Fort",
description: "Sinhagad Fort is a historic hill fort and one of the most popular destinations for day trips from Pune. A dedicated bus makes group travel more convenient for families, students, trekking groups, tourists, and friends planning to spend the day exploring the fort and its surroundings."
},
{
title: "Khadakwasla Dam",
description: "Khadakwasla Dam is located on the route toward the Sinhagad region and is a popular stop for visitors planning a short recreational outing. Groups can include the dam in their itinerary before or after visiting Sinhagad Fort while traveling together in a dedicated bus."
},
{
title: "Panshet Dam",
description: "Panshet is known for its reservoir, surrounding hills, and scenic environment and can be included in an extended Sinhagad-area outing. A group bus provides convenient transportation for families, friends, and corporate teams planning multiple scenic stops."
},
{
title: "Torna Fort",
description: "Torna Fort is an important trekking and historical destination in the Sahyadri region and is suitable for adventure-focused groups. A dedicated bus can support transportation for trekking groups traveling from Pune toward the fort region as part of a planned outdoor itinerary."
},
{
title: "Rajgad Fort",
description: "Rajgad Fort is a prominent historic fort and a popular destination for trekking enthusiasts and history lovers. Groups can arrange dedicated transportation from Pune for an extended fort tour that combines Sinhagad and other nearby heritage destinations."
},
{
title: "Pashan Lake",
description: "Pashan Lake is a peaceful nature destination within Pune and can be included in a local sightseeing program before or after a fort excursion. Group transportation allows families and organized groups to combine city and outdoor attractions within one planned journey."
},
{
title: "Parvati Hill",
description: "Parvati Hill is a well-known Pune landmark offering city views along with historical and religious significance. It can be included in a Pune sightseeing itinerary before traveling toward Sinhagad when groups want to combine city attractions with a fort visit."
},
{
title: "Saras Baug",
description: "Saras Baug is a popular recreational destination in Pune and can be included in family or group sightseeing programs. A dedicated bus makes it easier to coordinate travel between city attractions and the Sinhagad route during a full-day outing."
},
{
title: "Rajiv Gandhi Zoological Park",
description: "Rajiv Gandhi Zoological Park is a popular attraction for families and educational groups in Pune. Groups can combine a zoo visit with a Sinhagad-area excursion when planning a longer local sightseeing program with dedicated transportation."
},
{
title: "Lal Mahal",
description: "Lal Mahal is an important historical landmark in central Pune and is frequently visited by tourists and history enthusiasts. A group bus can connect the landmark with Sinhagad Fort as part of a broader Pune heritage and sightseeing itinerary."
}
],
services: [
{
name: "Pune to Sinhagad Bus Rental",
description: "Pune to Sinhagad Bus Rental provides dedicated group transportation for families, friends, tourists, students, trekking groups, and corporate teams. The bus can be selected according to passenger capacity, trip duration, luggage requirements, and the planned Sinhagad itinerary."
},
{
name: "Pune to Sinhagad Bus Hire",
description: "Pune to Sinhagad Bus Hire is suitable for groups planning a fort visit, picnic, trekking trip, or weekend outing. A dedicated vehicle allows everyone to travel together from Pune and coordinate the journey according to their preferred departure and return schedule."
},
{
name: "Pune Sinhagad Bus Booking",
description: "Pune Sinhagad Bus Booking allows groups to arrange their transportation before the planned travel date. Bus requirements can be organized around passenger strength, pickup location, AC preference, travel duration, sightseeing plans, and return timing."
},
{
name: "Sinhagad Fort Tour Bus Pune",
description: "Sinhagad Fort Tour Bus Pune provides convenient group transportation for visitors exploring the historic fort and surrounding attractions. The itinerary can include Sinhagad along with Khadakwasla, nearby scenic locations, or other Pune attractions according to the group's available time."
},
{
name: "Sinhagad Darshan Bus from Pune",
description: "Sinhagad Darshan Bus from Pune is suitable for families, tourists, students, and groups visiting the fort for its historical and scenic importance. Dedicated transportation helps coordinate the complete journey from selected Pune pickup points to Sinhagad and back."
},
{
name: "Pune Sinhagad AC Bus Rental",
description: "Pune Sinhagad AC Bus Rental provides a comfortable travel option for groups making the journey from Pune to the Sinhagad region. Air-conditioned transportation is particularly useful for families, corporate groups, and tourists planning a full-day excursion."
},
{
name: "Sinhagad Tourist Bus Pune",
description: "Sinhagad Tourist Bus Pune is designed for visitors traveling to the fort and nearby attractions as part of an organized sightseeing program. A dedicated bus provides convenient group transportation while allowing passengers to follow a planned route and schedule."
},
{
name: "Pune Sinhagad Group Tour Bus",
description: "Pune Sinhagad Group Tour Bus is suitable for friends, college groups, community groups, trekking parties, and organized tourist groups. The vehicle capacity can be selected according to the number of travelers to keep the entire group together during the excursion."
},
{
name: "Pune Sinhagad Family Tour Bus",
description: "Pune Sinhagad Family Tour Bus provides convenient transportation for families planning a day outing to the fort and surrounding destinations. Family members can travel together from Pune and include scenic stops, meal breaks, and sightseeing according to their itinerary."
},
{
name: "Pune Sinhagad Picnic Bus",
description: "Pune Sinhagad Picnic Bus is suitable for families, schools, companies, friends, and social groups planning a recreational outing. A dedicated bus can transport the complete group between Pune, Sinhagad, and other selected picnic or sightseeing locations."
},
{
name: "Sinhagad One Day Tour Bus Pune",
description: "Sinhagad One Day Tour Bus Pune is ideal for groups planning a same-day excursion from Pune. The journey can be structured around an early departure, fort sightseeing, nearby attractions, meal breaks, leisure time, and a scheduled return to the city."
},
{
name: "Pune Sinhagad Sightseeing Bus",
description: "Pune Sinhagad Sightseeing Bus provides group transportation for visitors wanting to explore Sinhagad and other attractions around the route. It can support itineraries that combine historical landmarks, scenic destinations, dams, and recreational locations."
},
{
name: "Pune Sinhagad Outstation Bus Hire",
description: "Pune Sinhagad Outstation Bus Hire is suitable for organized groups traveling beyond the regular city area for a fort excursion or extended regional tour. The bus can be arranged according to group size, travel duration, route, sightseeing plan, and return requirements."
},
{
name: "Affordable Sinhagad Bus Rental Pune",
description: "Affordable Sinhagad Bus Rental Pune offers a practical transportation option for groups planning a budget-conscious fort trip. Selecting an appropriately sized vehicle and organizing an efficient itinerary can help balance transportation costs with group comfort."
},
{
name: "Luxury Bus for Sinhagad Tour Pune",
description: "Luxury Bus for Sinhagad Tour Pune is suitable for premium family outings, corporate groups, special events, and travelers who prefer enhanced comfort. A luxury vehicle can make the road journey more pleasant when the group plans a full-day sightseeing program."
},
{
name: "Sinhagad Fort Group Transportation Pune",
description: "Sinhagad Fort Group Transportation Pune provides centralized travel arrangements for large groups visiting the fort. It is useful for schools, trekking groups, families, corporate teams, and tourists who want to coordinate their journey using a common vehicle."
},
{
name: "Pune to Sinhagad AC Bus Hire",
description: "Pune to Sinhagad AC Bus Hire provides comfortable air-conditioned transportation for groups traveling to the fort region. The service is suitable for family trips, tourist excursions, corporate outings, school programs, and organized day tours."
},
{
name: "Sinhagad Fort Bus Booking Service Pune",
description: "Sinhagad Fort Bus Booking Service Pune helps groups arrange suitable transportation for planned fort visits and sightseeing programs. Requirements such as travel date, passenger count, pickup location, vehicle category, and expected return time can be considered while planning the journey."
},
{
name: "Sinhagad Tour Package by Bus Pune",
description: "Sinhagad Tour Package by Bus Pune provides an organized group transportation solution for visitors exploring the fort and nearby attractions. The tour can be planned as a one-day excursion with selected sightseeing stops, breaks, and convenient return transportation."
},
{
name: "Pune Sinhagad Weekend Bus Tour",
description: "Pune Sinhagad Weekend Bus Tour is suitable for friends, families, trekking groups, and corporate teams planning a short weekend outing. The journey can be combined with nearby scenic and recreational destinations for a more complete weekend itinerary."
},
{
name: "Sinhagad Trek Group Bus Pune",
description: "Sinhagad Trek Group Bus Pune provides dedicated transportation for trekking groups traveling from Pune toward the fort. The vehicle can accommodate the group and their travel requirements while allowing trekkers to coordinate a common departure and return schedule."
},
{
name: "Pune to Sinhagad Tourist Bus",
description: "Pune to Sinhagad Tourist Bus is suitable for visitors who want organized transportation to the historic fort and surrounding sightseeing locations. A dedicated bus allows tourists to travel together and follow an itinerary covering selected attractions along the route."
}
],
tableData: [
["Pune to Sinhagad Bus Rental", "Pune to Sinhagad Bus Hire"],
["Pune Sinhagad Bus Booking", "Sinhagad Fort Tour Bus Pune"],
["Sinhagad Darshan Bus from Pune", "Pune Sinhagad AC Bus Rental"],
["Sinhagad Tourist Bus Pune", "Pune Sinhagad Group Tour Bus"],
["Pune Sinhagad Family Tour Bus", "Pune Sinhagad Picnic Bus"],
["Sinhagad One Day Tour Bus Pune", "Pune Sinhagad Sightseeing Bus"],
["Pune Sinhagad Outstation Bus Hire", "Affordable Sinhagad Bus Rental Pune"],
["Luxury Bus for Sinhagad Tour Pune", "Sinhagad Fort Group Transportation Pune"],
["Pune to Sinhagad AC Bus Hire", "Sinhagad Fort Bus Booking Service Pune"],
["Sinhagad Tour Package by Bus Pune", "Pune Sinhagad Weekend Bus Tour"],
["Sinhagad Trek Group Bus Pune", "Pune to Sinhagad Tourist Bus"]
],
whychoose: [
{
WhyChooseheading: "Convenient Fort Trip from Pune",
WhyChoosedescription: "A dedicated bus provides an organized way for groups to travel from Pune to Sinhagad without arranging multiple cars. The journey can be planned around convenient pickup points, preferred departure timings, sightseeing requirements, and the group's return schedule."
},
{
WhyChooseheading: "Ideal for One-Day Excursions",
WhyChoosedescription: "Sinhagad is well suited to a same-day outing from Pune, allowing groups to enjoy a fort visit and return within one planned journey. Transportation can be coordinated around early departure, sightseeing time, meal breaks, and return travel."
},
{
WhyChooseheading: "Suitable for Trekking Groups",
WhyChoosedescription: "Trekking groups often travel with friends, classmates, or organized adventure teams and benefit from having common transportation. A dedicated bus keeps the group together while providing a convenient travel arrangement for the Sinhagad excursion."
},
{
WhyChooseheading: "Comfortable AC Travel Options",
WhyChoosedescription: "Groups spending an entire day on the road can benefit from a comfortable transportation environment. AC bus options are suitable for families, tourists, corporate teams, school groups, and visitors planning an extended sightseeing program."
},
{
WhyChooseheading: "Useful for Families and Picnics",
WhyChoosedescription: "Family groups and picnic parties can travel together instead of coordinating several private vehicles. The bus can accommodate the group while allowing the itinerary to include Sinhagad, Khadakwasla, and other nearby recreational destinations."
},
{
WhyChooseheading: "Flexible Sightseeing Routes",
WhyChoosedescription: "A Sinhagad trip does not have to be limited to the fort alone. Groups can plan additional stops such as Khadakwasla Dam or other Pune attractions, creating a more complete day itinerary around their available travel time."
},
{
WhyChooseheading: "Options for Different Groups",
WhyChoosedescription: "Sinhagad visitors can include tourists, families, students, corporate employees, and trekking enthusiasts with different transportation needs. Vehicle capacity and comfort preferences can be considered according to the size and nature of the group."
},
{
WhyChooseheading: "Easy Round-Trip Coordination",
WhyChoosedescription: "Planning onward and return transportation together simplifies the day's logistics for a group excursion. A dedicated bus can follow the planned schedule from Pune to the Sinhagad region and remain part of the return transportation arrangement."
}
]
};











const faqData = [
{
question: "Can I hire a bus from Pune to Sinhagad Fort?",
answer: "A dedicated bus can be hired from Pune for a group trip to Sinhagad Fort, making it convenient for families, friends, school groups, and organizations traveling together. Ruturaj Enterprises can arrange suitable group transportation based on the number of passengers and the planned travel schedule."
},
{
question: "Is a bus rental suitable for a Sinhagad Fort one-day trip?",
answer: "A one-day bus rental works well for a Sinhagad Fort excursion from Pune. The group can coordinate departure, sightseeing, meal breaks, and the return journey around a single itinerary, avoiding the need to arrange separate vehicles for different travelers."
},
{
question: "What type of groups can book a bus for Sinhagad Fort from Pune?",
answer: "Families, college groups, corporate teams, school groups, friends, tourist groups, and community organizations can use a rented bus for a Sinhagad Fort visit. Vehicle selection can be planned according to group size, luggage requirements, and the overall duration of the outing."
},
{
question: "How far is Sinhagad Fort from Pune by road?",
answer: "Sinhagad Fort is a popular excursion destination near Pune and can be reached by road through the Khadakwasla and Sinhagad-side route. Travel time may vary depending on the starting point in Pune, traffic conditions, road conditions, and the chosen schedule."
},
{
question: "Can I hire an AC bus for a Pune to Sinhagad Fort trip?",
answer: "An AC bus can be considered for groups looking for a more comfortable journey, particularly when traveling during warmer months. Ruturaj Enterprises can help identify a suitable vehicle based on passenger capacity, trip requirements, and the preferred level of travel comfort."
},
{
question: "Can a school or college group rent a bus for Sinhagad Fort?",
answer: "Educational groups can arrange a dedicated bus for an excursion to Sinhagad Fort from Pune. Keeping students and accompanying staff in one vehicle makes attendance coordination, departure planning, group movement, and the return journey more manageable."
},
{
question: "Can corporate teams hire a bus from Pune to Sinhagad Fort?",
answer: "Corporate groups can use a rented bus for team outings, employee recreational trips, and informal team-building activities at Sinhagad Fort. A private vehicle allows colleagues to travel together and maintain a coordinated schedule throughout the excursion."
},
{
question: "What bus seating capacity is suitable for a Sinhagad Fort trip?",
answer: "The appropriate seating capacity depends on the total number of passengers traveling together. Smaller groups may need a compact vehicle, while larger groups can choose higher-capacity options after considering passenger count, luggage, comfort, and the planned sightseeing itinerary."
},
{
question: "Can we include Khadakwasla Dam with Sinhagad Fort in the same trip?",
answer: "Khadakwasla Dam can be included in a Pune to Sinhagad Fort itinerary when the group's available travel time allows it. The route and sightseeing sequence can be planned in advance so that the group can visit both locations while keeping the day's transportation organized."
},
{
question: "Why choose Ruturaj Enterprises for a Pune to Sinhagad Fort bus rental?",
answer: "Ruturaj Enterprises focuses on organized group transportation for local sightseeing and outstation-style excursions from Pune. The vehicle can be selected according to group size and trip requirements, helping passengers travel together with a planned pickup, sightseeing schedule, and return journey."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Akash Jadhav",
feedback:
"We arranged a bus from Ruturaj Enterprises for a group trip from Pune to Sinhagad Fort. The single vehicle made it easier for everyone to travel together and follow our planned schedule. It was a convenient option for our full-day outing.",
rating: 5
},
{
id: 2,
name: "Miss. Priya Deshmukh",
feedback:
"Our friends' group planned a Sinhagad Fort visit and needed comfortable transportation from Pune. Ruturaj Enterprises arranged a suitable bus for us, which made the journey and return trip much easier to coordinate. The overall experience was smooth and convenient.",
rating: 5
}
];





































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Sinhagad Fort Bus on rent in Pune",
  "image": "https://ruturajenterprises.com/assets/images/pune-to-sinhagad-fort-bus-on-rent-in-pune.webp",
  "description":
    "Pune to Sinhagad Fort Bus on rent in Pune for family outings, group trips, school tours, college excursions, corporate outings, and local sightseeing. Ruturaj Enterprises provides comfortable AC and luxury buses for travel from Pune to Sinhagad Fort with suitable seating capacities, experienced drivers, convenient pickup arrangements, and flexible rental options for one-day trips and sightseeing around Sinhagad and nearby attractions.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/pune-to-sinhagad-fort-bus-on-rent-in-pune"
  }
};





    return (
        <div>
<Helmet>
  <title>
    Pune to Sinhagad Fort Bus on rent in Pune | Sinhagad Tour Bus | +91 9763381382
  </title>

  <meta
    name="description"
    content="Pune to Sinhagad Fort Bus on rent in Pune for family trips, group outings, school tours, college trips, corporate outings and sightseeing. Hire comfortable AC and luxury buses for a convenient Sinhagad Fort tour from Pune."
  />

  <meta
    name="keywords"
    content="Pune to Sinhagad Bus Rental, Pune to Sinhagad Bus Hire, Pune Sinhagad Bus Booking, Sinhagad Fort Tour Bus Pune, Sinhagad Darshan Bus from Pune, Pune Sinhagad AC Bus Rental, Sinhagad Tourist Bus Pune, Pune to Sinhagad Fort Bus Rental, Pune to Sinhagad Fort Bus Hire, Pune to Sinhagad Fort Bus Booking, Pune Sinhagad Fort Tour Bus, Sinhagad Fort Bus Rental Pune, Sinhagad Fort Bus Hire Pune, Sinhagad Fort Bus Booking Pune, Sinhagad Fort Tourist Bus from Pune, Sinhagad Fort Sightseeing Bus Pune, Sinhagad Darshan Bus Rental Pune, Sinhagad Darshan Bus Hire Pune, Sinhagad Tour Package from Pune by Bus, Pune Sinhagad Tour Package, Pune Sinhagad One Day Tour Bus, Pune Sinhagad Weekend Tour Bus, Pune Sinhagad Group Tour Bus, Pune Sinhagad Family Tour Bus, Pune Sinhagad Picnic Bus, Pune Sinhagad School Trip Bus, Pune Sinhagad College Trip Bus, Pune Sinhagad Corporate Outing Bus, Pune Sinhagad AC Tourist Bus, Pune Sinhagad Luxury Bus Rental, Pune Sinhagad Luxury Bus Hire, Pune Sinhagad Local Bus Rental, Pune Sinhagad Local Sightseeing Bus, Bus on Rent Pune to Sinhagad, AC Bus on Rent Pune to Sinhagad, Luxury Bus on Rent Pune to Sinhagad, Tourist Bus Pune to Sinhagad, Group Bus Pune to Sinhagad, Family Bus Pune to Sinhagad, One Day Bus Rental Pune Sinhagad, Sinhagad Fort One Day Trip Bus Pune, Sinhagad Fort Family Tour Bus Pune, Sinhagad Fort Group Tour Bus Pune, Sinhagad Fort Picnic Bus Pune, Sinhagad Fort School Tour Bus Pune, Sinhagad Fort College Tour Bus Pune, Sinhagad Fort Corporate Tour Bus Pune, Pune to Sinhagad Fort Tourist Bus, Pune to Sinhagad Fort Sightseeing Bus, Pune to Sinhagad Fort Outstation Bus Hire, 20 Seater Bus Pune to Sinhagad, 32 Seater Bus Pune to Sinhagad, 35 Seater Bus Pune to Sinhagad, 45 Seater Bus Pune to Sinhagad, 50 Seater Bus Pune to Sinhagad, Affordable Sinhagad Bus Rental Pune, Sinhagad Bus Rental Near Me Pune, Sinhagad Fort Tour Bus Service Pune, Ruturaj Enterprises Sinhagad Bus Rental Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/38.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetosinhghadfort ;